import type { NextPage } from 'next';
import React from 'react';
import Header from '../src/Components/molecules/Header/Header';
import Footer from '../src/Components/molecules/Footer/Footer';
import { getPostList as IgetPostList } from '../src/lib/api/types';
import HeadCustom from '../src/Components/molecules/Head/Head';
import PrivacyContent from '../src/Components/Conents/privacyContent';

const Privacy: NextPage<IgetPostList> = () => (
    <>
        <HeadCustom />
        <Header />

        <section className="relative mx-auto flex w-full max-w-5xl flex-col gap-1 px-4 lg:px-0">
            <PrivacyContent />
        </section>

        <Footer />
    </>
);

export default Privacy;
